module.exports = __webpack_public_path__ + "static/img/17.1eb48b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/17.png
// module id = K4ZP
// module chunks = 0